import { render, staticRenderFns } from "./DetailsSectionMessagesHistory.vue?vue&type=template&id=56b2b2b6&"
import script from "./DetailsSectionMessagesHistory.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionMessagesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports